// Native dialogs retain keyboard containment and restore focus to their own trigger.
const header = document.getElementById('site-header');
const menu = document.getElementById('mobile-menu');
const menuButton = document.querySelector('.menu-toggle');
const offer = document.getElementById('offer-dialog');
const triggers = new WeakMap();
const closing = new WeakMap();
const animations = new WeakMap();
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
const motion = (element, frames, duration = 180) => element.animate(frames, {duration: reducedMotion.matches ? 0 : duration, easing: 'ease-out'});
function closeDialog(dialog) {
  if (closing.has(dialog)) return closing.get(dialog);
  if (!dialog.open) return Promise.resolve();
  animations.get(dialog)?.cancel();
  const offset = dialog === menu ? 'translateX(16px)' : 'translateY(10px)';
  const animation = motion(dialog, [{opacity:1,transform:'translate(0)'},{opacity:0,transform:offset}],160);
  animations.set(dialog, animation);
  const done = animation.finished.catch(() => {}).then(() => {
    dialog.close();
    closing.delete(dialog);
  });
  closing.set(dialog, done);
  return done;
}
async function openDialog(dialog, trigger) {
  if (dialog.open && !closing.has(dialog)) return;
  if (closing.has(dialog)) await closing.get(dialog);
  const others = [...document.querySelectorAll('dialog[open]')].filter(other => other !== dialog);
  await Promise.all(others.map(closeDialog));
  if (dialog.open) return;
  triggers.set(dialog, trigger);
  dialog.showModal();
  if (dialog === offer) {dialog.scrollTop = 0;dialog.querySelector('[data-guided-offer]')?.bossnetGuided?.open();}
  const offset = dialog === menu ? 'translateX(16px)' : 'translateY(10px)';
  animations.set(dialog, motion(dialog, [{opacity:0,transform:offset},{opacity:1,transform:'translate(0)'}],200));
  document.body.classList.add('dialog-open');
  header.classList.remove('is-hidden');
  if (dialog === menu) menuButton.setAttribute('aria-expanded', 'true');
}
document.querySelectorAll('dialog').forEach(dialog => {
  dialog.addEventListener('cancel', event => {event.preventDefault();closeDialog(dialog);});
  dialog.querySelector('.close-dialog')?.addEventListener('click', () => closeDialog(dialog));
  dialog.querySelector('[data-close-offer]')?.addEventListener('click', () => closeDialog(dialog));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
  });
  dialog.addEventListener('close', () => {
    const anotherOpen = !!document.querySelector('dialog[open]');
    document.body.classList.toggle('dialog-open', anotherOpen);
    if (dialog === menu && !menu.open) menuButton.setAttribute('aria-expanded', 'false');
    if (!anotherOpen) {
      const trigger = triggers.get(dialog);
      const visible = trigger?.isConnected && trigger.getClientRects().length;
      (visible ? trigger : menuButton)?.focus({preventScroll:true});
    }
  });
});
function isOfferLink(link) {
  if (!link?.href || link.hasAttribute('download') || (link.target && link.target !== '_self')) return false;
  const url = new URL(link.href, location.href);
  return url.origin === location.origin && ['/pages/cere-oferta', '/cere-oferta'].includes(url.pathname.replace(/\/$/, ''));
}
menuButton.addEventListener('click', () => openDialog(menu, menuButton));
menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
  if (!isOfferLink(link)) closeDialog(menu);
}));
document.addEventListener('click', event => {
  const link = event.target.closest('a[href]');
  if (!offer || !isOfferLink(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  openDialog(offer, menu.contains(link) ? menuButton : link);
});
document.querySelectorAll('a[href]').forEach(link => {
  if (isOfferLink(link)) {link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-controls','offer-dialog');}
});
const desktopQuery = matchMedia('(min-width: 1025px)');
desktopQuery.addEventListener('change', event => { if (event.matches && menu.open) closeDialog(menu); });

const dropdown = document.querySelector('.nav-dropdown');
const servicesToggle = document.querySelector('.services-toggle');
const servicesMenu = document.getElementById('services-menu');
let dropdownClicked = false;
let dropdownOpen = false;
let dropdownAnimation;
let leaveTimer;
function setDropdown(open) {
  clearTimeout(leaveTimer);
  if (dropdownOpen === open) return;
  dropdownOpen = open;
  if (!open) dropdownClicked = false;
  servicesToggle.setAttribute('aria-expanded', String(open));
  dropdownAnimation?.cancel();
  if (open) {
    servicesMenu.hidden = false;
    servicesMenu.inert = false;
    header.classList.remove('is-hidden');
  } else servicesMenu.inert = true;
  dropdownAnimation = motion(servicesMenu, open
    ? [{opacity:0,transform:'translateY(-8px)'},{opacity:1,transform:'translateY(0)'}]
    : [{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(-8px)'}], open ? 180 : 130);
  dropdownAnimation.finished.then(() => {if (!dropdownOpen) servicesMenu.hidden = true;}).catch(() => {});
}
servicesToggle.addEventListener('click', () => {
  const open = !dropdownClicked;
  setDropdown(open);
  dropdownClicked = open;
});
dropdown.addEventListener('mouseenter', () => {clearTimeout(leaveTimer);if (matchMedia('(hover: hover)').matches) setDropdown(true);});
dropdown.addEventListener('mouseleave', () => {
  leaveTimer = setTimeout(() => {if (!dropdown.contains(document.activeElement)) setDropdown(false);}, 160);
});
dropdown.addEventListener('focusout', event => {if (!dropdown.contains(event.relatedTarget)) setDropdown(false);});
document.addEventListener('click', event => {if (!dropdown.contains(event.target)) setDropdown(false);});
dropdown.addEventListener('keydown', event => {
  if (event.key === 'Escape') {setDropdown(false);servicesToggle.focus();}
  if (event.key === 'ArrowDown' && event.target === servicesToggle) {event.preventDefault();setDropdown(true);servicesMenu.querySelector('a').focus();}
});
desktopQuery.addEventListener('change', () => setDropdown(false));

let previousScroll = 0;
let scheduledScroll = false;
window.addEventListener('scroll', () => {
  if (scheduledScroll) return;
  scheduledScroll = true;
  requestAnimationFrame(() => {
    const current = window.scrollY;
    const change = current - previousScroll;
    const locked = !!document.querySelector('dialog[open]') || !servicesMenu.hidden || header.contains(document.activeElement);
    if (current < 100 || locked) header.classList.remove('is-hidden');
    else if (Math.abs(change) > 10) header.classList.toggle('is-hidden', change > 0);
    if (Math.abs(change) > 10 || current < 100) previousScroll = current;
    scheduledScroll = false;
  });
}, { passive: true });
header.addEventListener('focusin', () => header.classList.remove('is-hidden'));


// Synchronize current navigation without hardcoded homepage aria-current.
function syncNavigation() {
  document.querySelectorAll('nav a[href]').forEach(link => {
    const url = new URL(link.href);
    const samePage = url.pathname === location.pathname;
    const blogPage = url.pathname === '/blogs/blog' && location.pathname.startsWith('/blogs/blog/');
    const active = url.hash ? samePage && url.hash === location.hash : (samePage || blogPage) && !(samePage && url.pathname === '/' && location.hash === '#despre-noi');
    if (active) link.setAttribute('aria-current', url.hash ? 'location' : 'page');
    else link.removeAttribute('aria-current');
  });
  menu.querySelectorAll('details').forEach(details => {
    const active = !!details.querySelector('a[aria-current]');
    if (active) details.open = true;
  });
}
syncNavigation();
window.addEventListener('hashchange', syncNavigation);

// Animate native disclosures while retaining their keyboard and no-JS behavior.
document.querySelectorAll('details').forEach(details => {
  const summary = details.querySelector('summary');
  if (!summary) return;
  let animation;
  summary.addEventListener('click', event => {
    if (reducedMotion.matches) return;
    event.preventDefault();
    animation?.cancel();
    const opening = !details.open;
    const start = details.getBoundingClientRect().height;
    if (opening) details.open = true;
    const end = opening ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
    details.style.overflow = 'hidden';
    animation = motion(details, [{height:start+'px'},{height:end+'px'}]);
    animation.finished.then(() => {details.open = opening;details.style.overflow = '';}).catch(() => {});
  });
});

// Open Shopify cookie preferences independently of analytics instrumentation.
document.addEventListener('click', event => {
  const preferences = event.target.closest('[data-privacy-preferences]');
  if (!preferences || typeof window.privacyBanner?.showPreferences !== 'function') return;
  event.preventDefault();
  Promise.resolve(window.privacyBanner.showPreferences()).catch(() => location.assign(preferences.href));
});

// Keep footer preferences and legal links clear of the floating contact button.
const siteFooter = document.querySelector('.site-footer');
const floatingContact = document.querySelector('.contact-trigger');
if (siteFooter && floatingContact) {
  new IntersectionObserver(entries => {
    const hidden = entries[0].isIntersecting;
    floatingContact.classList.toggle('is-near-footer',hidden);
    floatingContact.inert = hidden;
    if (hidden) floatingContact.setAttribute('aria-hidden','true');
    else floatingContact.removeAttribute('aria-hidden');
  }, {threshold:0}).observe(siteFooter);
}
